export const getTestStatus = (passing) => {
    const statusesMap = {
        'questionnaire': 'В процессе',
        'instruction': 'В процессе',
        'expired': 'Не пройден',
        'new': 'Не начат',
        'in_progress': 'В процессе',
        'finished': 'Завершен',
    }

    if (passing.status) {
        return statusesMap[passing.status] ?? 'Не начат';
    }
};
